/* Version: 3.5.137 */
'use client';
import 'react';
import { Square } from '@manulife/mux-logos';
import i18n from '../../lang/i18n/index.js';
import LogoComponent from './LogoComponent.js';
import { jsx } from 'react/jsx-runtime';
import useLang from '../../hooks/useLang.js';
import useTheme from '../../hooks/useTheme.js';

var BrandLogo = function BrandLogo(_ref) {
  var _mobileProps$logo, _mobileProps$logo2;
  var alt = _ref.alt,
    as = _ref.as,
    href = _ref.href,
    onClick = _ref.onClick,
    isWideMainNav = _ref.isWideMainNav,
    mobileProps = _ref.mobileProps;
  var lang = useLang();
  var theme = useTheme();
  var height = isWideMainNav ? theme.sideNav.brandLogo.width : '80px';
  var width = isWideMainNav ? theme.sideNav.brandLogo.height : '80px';
  return /*#__PURE__*/jsx(LogoComponent, {
    as: as,
    "aria-label": alt || i18n[lang].sideNav.brandLogo,
    "data-testid": "brand-logo-component",
    href: href,
    onClick: onClick,
    style: {
      height: mobileProps ? (_mobileProps$logo = mobileProps.logo) === null || _mobileProps$logo === undefined || (_mobileProps$logo = _mobileProps$logo.brand) === null || _mobileProps$logo === undefined ? undefined : _mobileProps$logo.height : height,
      width: mobileProps ? (_mobileProps$logo2 = mobileProps.logo) === null || _mobileProps$logo2 === undefined || (_mobileProps$logo2 = _mobileProps$logo2.brand) === null || _mobileProps$logo2 === undefined ? undefined : _mobileProps$logo2.width : width
    },
    children: /*#__PURE__*/jsx(Square.GREEN, {
      id: "brand-logo",
      "data-testid": "brand-logo",
      title: alt || i18n[lang].sideNav.brandLogo
    })
  });
};

export { BrandLogo as default };
